<template>
    <div class="Message xi">
        <nh-com v-if="msgType == 0"></nh-com>
        <h-com v-if="msgType == 1"></h-com>
        <div class="personal-content">
            <div class="personal-box clearfix">
                <div class="personalmesBox">
                    <div class="personal-left">
                                  
                         <el-menu
                            :collapse="false"
                            :default-openeds="list"
                            class="el-menu-vertical-demo" @select="handleSelect">
                                <el-submenu :index="index+''" v-for="(item,index) in MessageList" :key="index">
                                    <template slot="title"><span slot="title">{{item.categoryName}}</span></template>
                                    <!-- :class="carId == (index + '-Z' + index1)  ? 'textColor' : ''"  -->
                                    <!-- , (index + '-Z' + index1)+'' -->
                                    <!-- @click="goMessageDetail(item1.id)" -->
                                    <el-menu-item :class="carId == (index + '-' + index1)  ? 'textColor' : ''" v-for="(item1,index1) in item.userManuals" :key="(index + '-' + index1)+''" :index="(index + '-' + index1)+''"  >
                                        <span >{{item1.title}}</span>
                                    </el-menu-item>
                                </el-submenu>  
                            </el-menu>
                    </div>
                    <div class="personal-right">
                        <div class="center-content">
                            <div class="contentBoxTitleR">
                                {{MessageDetail.title}}
                            </div>
                            <div style="padding: 30px;" v-html="MessageDetail.userManualDescription"></div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <ft-com></ft-com>
    </div>
</template>

<script>
import { MessageDomain } from '../components/personal/Message';
import ftCom from '../components/footer'
import nhCom from "../components/navheader";
import hCom from "../components/header";
import hdImg from "../components/headerImg";
var pageIndex = 1;
var keywordVal = ''
export default {
    name: "Message",
    components: {
        ftCom,
        nhCom,
        hdImg,
        hCom
    },
    data() {
        var MessageDomainTemp = new MessageDomain(this.TokenClient, this.Services.Statics);
        return {
            labelPosition: 'right',
            MessageList: [],
            MessageDetail: {},
            total: 0,
            currentPage: 1, //初始页
            keyword: '',
            PageIndex: 1,
            PageTotal: 1,
            MessageTotal: 0,
            rloading: [],//loading遮罩
            Result: MessageDomainTemp,
            Image: {
                //单击图片上传控件中的图片时，放大显示
                dialogVisible: false,
                dialogImageUrl: '',
            },
            msgIndex: 0,
            msgType: this.$route.query.typeCom ? this.$route.query.typeCom : 0,
            activeNames: ['1'],
            homeMessage: [],
            unreadCountXt: 0,
            unreadCountZf: 0,
            unreadCountZz: 0,
            unreadCountMz:0,
            PageIndexP:1,
            PageTotalP:1,
            MessageTotalP:1,
            currentPageP: 1, //初始页
            MessageListP:[],
            http:'',
            isCollapse:false,
            carId:'0-0',
            list:['0']
        };
    },
    mounted() {
        this.http = this.Services.ossUpload;
        if (this.$route.query.msgIndex) {
            this.msgIndex = this.$route.query.msgIndex;
        }
        this.AllMessages();
    },
    methods: {
        handleSelect(e){
            this.list = []
            this.carId = e
            let f = e.split('-')
            this.list.push(f[0])
            this.goMessageDetail(this.MessageList[f[0]].userManuals[f[1]].id)
        },
          handleOpen(key, keyPath) {
                console.log(key, keyPath);
            },
        handleClose(key,filePath){
            console.log(key)
            console.log(filePath)
        },
        goMessageDetail(id) {
            var _this = this
            // _this.carId = id1
            _this.Result.getUserManualDetail(id, function (data) {
                _this.MessageDetail = data.data;
            }, function (error) {
                console.log(error);
            })
        },
        gomsgIndex(e) {
            this.msgIndex = e
            this.PageIndex = 1;
        },
        handleImagePreview(file) {
            this.Image.dialogImageUrl = file.filePath;
            this.Image.dialogVisible = true;
        },
        //返回列表页
        goBack() {
            $('.center-content').show();
            $('.personal-right-tit').show();
            $('.msg-detail').hide();

        },
        toDetail(i) {
            var _this = this;
            $('.center-content').hide();
            $('.personal-right-tit').hide();
            $('.msg-detail').show();
            _this.Result.MessageDetails(_this.MessageList[i].id, function (data) {
                _this.MessageDetail = data.data;
            }, function (error) {
                console.log(error);
            })
        },
        AllMessages() {
            // type 0 系统消息  2 快递消息  3 支付消息 （支出和入账）4 账号消息5 申请消息6 门诊消息 7 转诊消息
            var _this = this;
            _this.rloading = this.openLoading();
            _this.MessageList = [];
            _this.Result.getUserManual(_this.Services.ClientId,'%20', function (data) {
                if (data.data) {
                    _this.MessageList = data.data;
                     _this.carId = '0-0'
                    _this.goMessageDetail(data.data[0].userManuals[0].id)
                }
            },
                function (err) {
                    console.log(err);
                    _this.MessageList = []
                }
            )
            _this.rloading.close()
        }
    }
}
</script>

<style scoped>
@import "../assets/css/footer.css";

@import "../assets/css/footer.css";

#page {
    text-align: center;
    padding: 100px 0 30px;
}

.contentBoxR {
    background: #F5F7FA;
    padding: 15px 30px;
    margin: 30px;
    margin-bottom: 0;
    display: flex;
    align-items: center;
}

.contentNone {
    width: 100%;
    text-align: center;
    margin: 20px 0;
}

.contentBoxRC {
    background: #ffffff;
    padding: 0 30px;
    margin-top: 10px;
    display: flex;
    /* align-items: center; */
}
.contentBoxRCP {
    background: #ffffff;
    padding: 0 30px;
    margin-top: 10px;
    display: flex;
    align-items: center;
}

.mesTopItemRead {
    background: #ffffff;
    padding: 0 30px;
    margin-top: 10px;
    display: flex;
    color: #999999;
}

.mesTopItemRead .collapseCon {
    color: #999999;
}

.contentBoxRLC {
    width: 30%;
    height: 47px;
    line-height: 47px;
    padding-left: 30px;
}
.contentBoxRLCP {
    width: 30%;
    height: 47px;
    line-height: 47px;
}

.contentBoxRRC {
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.contentBoxRRC ::v-deep .el-collapse {
    width: 100% !important;
    border: none !important;
}

.contentBoxRRC ::v-deep .el-collapse .el-collapse-item__wrap {
    border: none !important;
}

.contentBoxRC .contentBoxRRC ::v-deep .el-collapse .el-collapse-item__header {
    border: none !important;
}

.mesTopItemRead .contentBoxRRC ::v-deep .el-collapse .el-collapse-item__header {
    border: none !important;
    color: #999999 !important;
}

.goHandl {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
}

.contentBoxRL {
    width: 30%;
}

.contentBoxRR {
    width: 70%;
}

.banner {
    width: 100%;
    height: 160px;
    background: url("../assets/img/news_banner.jpg") center no-repeat;
}

.banner-wrap {
    position: relative;
    width: 1200px;
    height: 100%;
    margin: 0 auto;
}

.banner-text {
    float: left;
}

.banner-text h3 {
    padding-top: 35px;
    font-size: 26px;
    font-weight: normal;
    color: #ffffff;
}

.banner-text p {
    font-size: 14px;
    color: #ffffff;
    margin-top: 20px;
}

.banner-text p a {
    color: #ffffff;
    font-size: 14px;
    margin: 0 5px;
}

/**/
.personal-content {
    background: #f7f7f7;
    padding: 40px 0;
}

.personalmesBox {
    display: flex;
    /* align-items: center; */
    justify-content: space-between;
    min-height: 740px;
}

.personal-box {
    margin: 0 auto;
}

.personal-left {
    width: 20%;
    min-height: 740px;
    background: #FFFFFF;
    border-radius: 10px;
    font-size: 14px;
    padding: 20px;
}

.personal-right {
    width: 80%;
    min-height: 740px;
    background: #FFFFFF;
    box-sizing: border-box;
    border-radius: 10px;
}

.personal-right-tit {
    border-bottom: 1px solid #e5e5e5;
    padding: 20px;
}

.personal-right-tit .iconfont {
    color: #04a290;
    font-size: 24px;
    margin-right: 5px;
}

.personal-right-tit span {
    display: inline-block;
    font-size: 24px;
    font-weight: 700;
    color: #333333;
}

.personal-right-tit span em {
    font-style: normal;
    color: #04a290;
}

.personal-right-tit .el-icon-delete {
    float: right;
    font-size: 18px;
}

.msg-list {
    padding: 0 20px;
}

.msg-list .msg-item {
    padding: 8px 0;
    border-bottom: 1px dashed #e5e5e5;
    line-height: 40px;
    height: 40px;
}

.msg-list .msg-item h4 {
    color: #999999;
    font-weight: normal;
    width: 700px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
}

.msg-list .msg-item.noread h4 {
    color: #333333;
}

.msg-list .msg-item p {
    color: #999999;
}

.msg-detail {
    padding: 20px;
    display: none;
}

.msg-detail .mess-tit {
    text-align: center;
}

.msg-detail .mess-info p {
    text-indent: 28px;
}

.mess-info .item-img {
    margin-right: 10px;
    display: flex;
    justify-content: flex-start;
    justify-items: center;
    flex-wrap: wrap;
}
.item-imgP {
    /* margin-right: 10px; */
    display: flex;
    justify-content: flex-start;
    justify-items: center;
    flex-wrap: wrap;
    width: 20%;
     padding-right: 15px;
}
.item-imgP img {
     width: 100%;
    
    /* margin: 0 1px; */
}
.item-imgP div {
    width: 100%;
    /* margin: 0 1px; */
}

.item-img img {
    width: 118px;
    margin: 0 1px;
    /* height: 118px; */
}

.contentBoxTitle {
    font-weight: bold;
    font-size: 20px;
    color: #333333;
    padding: 30px;
    padding-bottom: 0;
    cursor: pointer;
}

.contentBoxTitleR {
    font-size: 16px;
    color: #333333;
    padding: 30px;
    padding-bottom: 0;
    cursor: pointer;
}

.mesTopItem1 {
    min-height: 25px;
    min-width: 25px;
    border-radius: 50%;
    color: #FFFFFF;
    background-color: #EB1E1E;
    position: absolute;
    top: 5px;
    right: 5px;
}

.contentBoxContent {
    width: 150px;
    padding: 10px;
    text-align: center;
    background: #333333;
    border-radius: 6px;
    color: #FFFFFF;
    margin-left: 30px;
    margin-top: 16px;
    cursor: pointer;
}

.contentBoxContentno {
    width: 150px;
    padding: 10px;
    border: 1px solid #999999;
    text-align: center;
    background: #ffffff;
    border-radius: 6px;
    color: #999999;
    margin-left: 30px;
    margin-top: 16px;
    cursor: pointer;
}
.textColor {
    background: #3E8DFF;
    border-radius: 2px;
    color: #FFFFFF;
}
</style>
